export default "__VITE_ASSET__BEjfW6V6__"